import { isMatching, P } from 'ts-pattern';

export const isColumnFiltersState = isMatching(
  P.array({
    id: P.string,
    value: P.any,
  }),
);
